export const DISPLAY_ERROR = 'DISPLAY_ERROR_LOM';
export const DISPLAY_SUCCESS = 'DISPLAY_SUCCESS_LOM';
export const ADD_NEW_TOKEN = 'ADD_NEW_TOKEN_LOM';
export const RECEIVE_TOKENS = 'RECEIVE_TOKENS_LOM';

export const displayError = text => ({
  type: DISPLAY_ERROR,
  payload: { text },
});

export const displaySuccess = text => ({
  type: DISPLAY_SUCCESS,
  payload: { text },
});

export const addNewToken = accessToken => ({
  type: ADD_NEW_TOKEN,
  payload: { accessToken },
});

export const receiveTokens = accessTokens => ({
  type: RECEIVE_TOKENS,
  payload: { accessTokens },
});
